<template>
  <div class="postal-code-input">
    <v-text-field
      v-bind="{
        ...$attrs,
      }"
      :id="postalCodeId"
      :append-inner-icon="pageloading ? 'mdi-spin mdi-loading' : ''"
      @keyup="(e) => searchAddress(e.target.value)"
      label="Postal Code"
      solo
      :rules="rules"
      v-mask="'######'"
      hide-spin-buttons
      flat
      color="cyan"
      v-model="zip_code"
    >
    </v-text-field>
    <v-menu
      max-width="300"
      v-model="searchMenu"
      v-if="postalAddressList.length > 1"
      max-height="400"
      offset-y
      left
      :activator="`#${postalCodeId}`"
    >
      <v-list>
        <v-list-item
          v-for="(item, index) in postalAddressList"
          :key="index"
          :value="index"
          class="border-b"
          @click="setAddress(item)"
        >
          <template v-slot:prepend>
            <v-icon size="24" class="me-3" :icon="'mdi-map'"></v-icon>
          </template>
          <v-list-item-title class="white-space-pre-wrap">{{
            item.description
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { QUERY } from "@/core/services/store/request.module";
import { lowerCase } from "lodash";
import ValidationMixin from "@/core/plugins/validation-mixin";

export default {
  mixins: [ValidationMixin],
  model: {
    prop: "value",
    event: "input",
  },
  name: "pending-line-item",
  props: {
    country: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: "postal-menu-activator",
    },
    value: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    countryCode: {
      type: String,
      default: null,
    },
  },
  data: () => {
    return {
      pageloading: false,
      timeoutLimit: 500,
      timeout: null,
      searchMenu: false,
      postalAddressList: [],
      zip_code: null,
      postalCodeId: "postal-id" + +new Date(),
    };
  },
  watch: {
    value(param) {
      this.zip_code = param;
    },
  },
  methods: {
    setAddress(address) {
      this.searchMenu = false;
      this.$emit("update:address", address);
    },
    searchAddress(number) {
      if (number) {
        let _this = this;
        let url = "";
        let Request = {};
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
          if (_this.country == "singapore") {
            /*  if (number && number.length < 6 && this.country == "singapore") { */
            url = "https://micro.businessthrust.com/api/onemap-api/search";
            Request = {
              search: number,
            };
            /*  }else{
              return false;
            }  */
          } else {
            url = "https://micro.businessthrust.com/api/google-api/search";
            Request = {
              search: number,
              country: _this.countryCode ? _this.countryCode : "in",
            };
          }
          _this.$store
            .dispatch(QUERY, {
              url: url,
              data: Request,
            })
            .then(({ data }) => {
              if (data && data.length) {
                _this.searchMenu = true;
                console.log(this.searchMenu);
                if (lowerCase(_this.countryCode) != "sg") {
                  _this.postalAddressList = data.map((row) => {
                    const _address_2 = row.description;
                    return {
                      address1: _address_2,
                      address2: null,
                      unit_number: null,
                      postal_code: "000000",
                      description: row.description,
                    };
                  });
                } else {
                  _this.postalAddressList = data.map((row) => {
                    const _unit_number = null;
                    const _address_1 = row.road_name;
                    const _address_2 = row.building;
                    const _postal_code =
                      row.postal_code != "NIL" ? row.postal_code : "000000";
                    const longitude =
                      row.longitude != "NIL" ? row.longitude : null;
                    const latitude =
                      row.latitude != "NIL" ? row.latitude : null;

                    return {
                      address1: _address_1,
                      address2: _address_2,
                      unit_number: _unit_number,
                      longitude: longitude,
                      latitude: latitude,
                      postal_code: _postal_code,
                      description: row?.address,
                    };
                  });
                }
              } else {
                _this.searchMenu = false;
              }

              if (
                _this.postalAddressList &&
                _this.postalAddressList.length == 1
              ) {
                // _this.setAddress(_this.postalAddressList[0]);
              }
            })
            .catch((error) => {
              _this.logError(error);
            });
        }, _this.timeoutLimit);
      }
    },
  },
  computed: {
    rules() {
      const rule = [
        this.validateRules.minLength(this.zip_code, "Postal Code", 2),
        this.validateRules.maxLength(this.zip_code, "Postal Code", 6),
      ];
      if (this.required) {
        rule.push(this.validateRules.required(this.zip_code, "Postal Code"));
      }
      return rule;
    },
  },
};
</script>
<style scoped></style>
